import { render, staticRenderFns } from "./DeliveryCreate.vue?vue&type=template&id=805b1268"
import script from "./DeliveryCreate.vue?vue&type=script&lang=js"
export * from "./DeliveryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports